<template>
  <div class="column">
    <div class="card dash-card" v-bind:class="getSizeClass()">
      <div class="card-header dash-card-header">
        <div style="height: 40px;"></div>
      </div>
      <!-- Cluster 6 -->
      <div class="card-body dash-card-body">
        <tableitem :overallByWave="getOverallByWave"
                   :kpi="getKpiCustomerTreatment"
                   :showNpsBar="true"
                   :monochrome="true"
                   :showPrewaves="false"
                   :useTitleOverKpiName="true"
                   :titleText="getKpiCustomerTreatmentName"
                   :isHeader="true" />
        <titleunderline />
        <div class="dash-card-inner">
          <tableitem :overallByWave="getOverallByWave"
                     :showNpsBar="true"
                     :showPrewaves="false"
                     :monochrome="true"
                     :kpi="getKpi6_1" />
          <tableitem :overallByWave="getOverallByWave"
                     :showNpsBar="true"
                     :showPrewaves="false"
                     :monochrome="true"
                     :kpi="getKpi6_1_1" />
          <tableitem :overallByWave="getOverallByWave"
                     :kpi="getKpi6_1_2" />
          <tableitem :overallByWave="getOverallByWave"
                     :showNpsBar="true"
                     :showPrewaves="false"
                     :monochrome="true"
                     :kpi="getKpi6_2" />
        </div>
        <div style="height: 18px;" />
      </div>
    </div>
    <div class="card dash-card" style="padding: 2px;">
      <tableitem :overallByWave="getOverallByWave"
                 :showNpsBar="true"
                 :monochrome="true"
                 :useTitleOverKpiName="true"
                 :titleText="getTextRecommend()"
                 :kpi="getKpi0_4"
                 :kpiPrewave="getKpi0_4Prewave" />
    </div>
    <!-- Shops Count Stats -->
    <div class="card dash-card" id="shops">
      <div class="card-header dash-card-header" style="height: 30px; background: transparent; ">
        <h3 class="spacing">{{$t('Webportal.DashboardBMW.NumberOfShops')}} <span class="smalltext">({{$t('Webportal.DashboardBMW.Total')}} {{ getShops }})</span></h3>
      </div>
      <div class="card-body dash-card-body">
        <ShopsOverall style="width: 100%; height:136px;"
                      :overallValues="getOverallByWave" />
      </div>
    </div>
    <LegendControl :showTextItems="false"
                   :showNpsInfo="true" />
  </div>
</template>

<script>

  import performanceitem from './PerformanceItem'
  import tableitem from './TableItem.vue'
  import WideNscItem from './WideNscItem.vue'
  import ShopsOverall from './ShopsOverall'
  import HeaderedBar from './HeaderedBar'
  import LegendControl from './LegendControl'
  import RecommendationTable from './RecommendationTable'
  import titleunderline from './TitleUnderline'
  import BrandMixin from '@/mixins/BrandMixin';

  export default {
    name: 'CustomerTreatmentColumnNew',

    mixins: [BrandMixin],

    components: {
      performanceitem,
      tableitem,
      WideNscItem,
      ShopsOverall,
      HeaderedBar,
      LegendControl,
      RecommendationTable,
      titleunderline
    },

    props: [
      'dashdata',
      'isBmwi',
      'selectedBrand'
    ],

    methods: {
      getText(key) {
        return this.$t('Webportal.DashboardBMW.' + key)
      },

      getBrands() {
        var brands = '';
        this.selectedBrand.forEach(n => {
          if (n.includes('BMW') || n.includes('MINI') || n.includes('xEV') || n.includes('GKL') || n.includes('Competitor')) {
            if (brands.length > 0) {
              brands = brands + ', ';
            }
            brands = brands + n.split('^')[1];
          }
        });
        return brands;
      },


      getTextRecommend() {
        return this.$t('Webportal.DashboardBMW.Recommend') + ' ' + this.getBrands() + ' *';
      },

      getOverallRecommendation() {
        if (this.dashdata && this.dashdata.Recommendation && _.size(this.dashdata.Recommendation) > 0)
          return this.dashdata.Recommendation[0]
      },

      getKpiByString: function (name) {
        if (this.dashdata && this.dashdata.KPI && _.size(this.dashdata.KPI) > 0) {
          let item = _.find(this.dashdata.KPI, (x) => x.KpiCode === name)
          if (item) return item
        }
      },

      getKpiGroupByString: function (name) {
        if (this.dashdata && this.dashdata.KPIGroup && _.size(this.dashdata.KPIGroup) > 0)
          return _.find(this.dashdata.KPIGroup, (x) => x.KpiCode === name)
      },

      getOverallItem: function () {
        if (this.dashdata && this.dashdata.Overall && _.size(this.dashdata.Overall) > 0)
          return this.dashdata.Overall[0]
        return undefined
      },

      getSizeClass() {
        if (this.isBmwi) {
          return 'headercard-bmwi'
        }
        return 'headercard-bmw'
      },
    },

    computed: {

      isNsc: function () {
        var _kpi = this.getKpiCustomerTreatment
        if (!_kpi || !_kpi.SurveyWave || _.size(_kpi.SurveyWave) === 0) {
          return false
        }
        var result = _kpi.SurveyWave[0].ResultNSC
        return result != undefined
      },

      getKpiCustomerTreatmentName: function () {
        const item = this.getKpiGroupByString('06. Customer Treatment Cockpit')
        if (item) {
          if (item.KpiName === 'Customer Treatment Cockpit') {
            return 'Customer Treatment*';
          }
          return item.KpiName;
        }
        return '-'
      },

      getOverallItemProperty: function () {
        return this.getOverallItem()
      },

      getOverallByWave: function () {
        if (this.dashdata && this.dashdata.OverallByWave && _.size(this.dashdata.OverallByWave) > 0)
          return this.dashdata.OverallByWave[0]
        return undefined
      },

      getShops: function () {
        const item = this.getOverallItem()
        if (!item) { return '-' }
        return item.NumberOfShopsTotal
      },

      getKpiCustomerTreatment: function () {
        return this.getKpiGroupByString('06. Customer Treatment Cockpit')
      },

      getKpi6_1: function () {
        return this.getKpiByString('6.1 Rating of sales consultation')
      },

      getKpi6_1_1: function () {
        return this.getKpiByString('6.1.1 PG Experience')
      },

      getKpi6_1_2: function () {
        return this.getKpiByString('6.1.2 GKL + Customer treatment')
      },

      getKpi6_2: function () {
        return this.getKpiByString('6.2 Consider buying a vehicle')
      },

      getKpi0_4: function () {
        return this.getKpiByString('0.4 Recommend Brand (Cockpit)')
      },
      getKpi0_4Prewave: function () {
        return this.getOverallRecommendation()
      },

      getSuccessFactorsGroup: function () {
        let item = this.getKpiGroupByString('Success factors');
        return !item ? '-' : item.KpiName;
      },

      getWorkingStandardGroup: function () {
        let item = this.getKpiGroupByString('Working Standard');
        return !item ? '-' : item.KpiName;
      }
    }
  }

</script>
<style scoped>


  .card-body {
    padding: 0px;
  }

  .left {
    overflow: hidden;
    min-height: 26px;
  }

  .right {
    float: right;
    min-height: 26px;
  }

  .ctNoNsc {
    width: 95%;
    float: left;
    text-align: center;
    margin-top: 3px;
    margin-left: 6px;
    margin-right: 6px;
  }

  .hasnonsc {
    width: 100%;
  }

  .hasnsc {
    width: 65%;
  }

  .hasnonscitem {
    width: 0%;
  }

  .hasnscitem {
    width: 30%;
  }

  .p {
    -moz-hyphens: auto;
    -webkit-hyphens: auto;
    -ms-hyphens: auto;
    -o-hyphens: auto;
    hyphens: auto;
    word-wrap: break-word;
    text-overflow: ellipsis;
    text-overflow: unset;
  }

  .headercard-bmw {
    height: 446px;
  }

  .headercard-bmwi {
    height: 446px;
  }

  .headercard-bmwmoto {
    height: 623px;
  }

  .headercard {
    height: 620px;
  }

  .column {
    margin: 0px;
    padding: 0px;
    min-height: 55px;
    position: relative;
    top: 0px;
    margin-block-end: 0px;
    margin-inline-end: 2px;
  }

  .nscHeader {
    min-height: 77px;
  }

  .noNscHeader {
    min-height: 60px;
  }

  h3 {
    font-size: 10pt;
    margin: 0pt;
    text-align: center;
    font-stretch: extra-condensed;
    letter-spacing: -0.12em;
    white-space: normal;
    margin-top: 4px;
    font-weight: bold;
  }

  .spacing {
    letter-spacing: unset;
  }
</style>
